/**
 * PlaybookBuilderStep.tsx
 * Playbook builder step for the onboarding wizard
 *
 * Simple wrapper that delegates to PlaybookBuilderContainer.
 * Follows the FeeConfigurationDetailStep pattern.
 */

import { forwardRef, useImperativeHandle, useRef } from 'react';
import { PlaybookBuilderContainer, PlaybookBuilderContainerRef } from './components/PlaybookBuilderContainer';

/**
 * Exposed methods via ref
 */
export interface PlaybookBuilderStepRef {
  flashInvalidPlaybooks: () => void;
}

/**
 * Playbook builder step component
 * Clean step that delegates to specialized container
 */
export const PlaybookBuilderStep = forwardRef<PlaybookBuilderStepRef>((_props, ref) => {
  const containerRef = useRef<PlaybookBuilderContainerRef>(null);

  useImperativeHandle(ref, () => ({
    flashInvalidPlaybooks: () => {
      containerRef.current?.flashInvalidPlaybooks();
    }
  }), []);

  return <PlaybookBuilderContainer ref={containerRef} />;
});

PlaybookBuilderStep.displayName = 'PlaybookBuilderStep';
